import "./styles.css";

const Alert = ({ data }) => {
  return (
    <div className={`alert ${data.type}`}>
      {data.type === "error" ? (
        <i className="fa fa-times-circle fa-2x" />
      ) : data.type === "success" ? (
        <i className="fa fa-check-circle fa-2x" />
      ) : data.type === "notice" ? (
        <i className="fa fa-exclamation-circle fa-2x" />
      ) : (
        <i className="fa fa-circle-o-notch fa-spin fa-2x" />
      )}
      <span>{data.text}</span>
    </div>
  );
};

export default Alert;
